
import { Component, Emit, Prop, PropSync, Vue, Watch } from 'nuxt-property-decorator'
import type { ProviderModel } from '@alao-frontend/erp-services'

import DetectGeolocationBtn from '~/components/sections/coverage/filter/DetectGeolocationBtn.vue'
import LocationField from '~/components/sections/coverage/filter/LocationField.vue'
import ProviderFilter from '~/components/sections/coverage/filter/ProviderFilter.vue'
import NetworkFilter from '~/components/sections/coverage/filter/NetworkFilter.vue'
import { NetworkType } from '~/components/sections/coverage/types'

@Component({
  components: {
    DetectGeolocationBtn,
    LocationField,
    ProviderFilter,
    NetworkFilter,
  },
})
export default class CoverageFilter extends Vue {
  @PropSync('providerId', { required: true, default: () => 0, type: Number })
  selectedProviderId!: number

  @PropSync('selectedNetwork', { required: true, default: () => '', type: String })
  selectedNetworkType!: NetworkType

  @Prop({ required: true, default: () => ([]), type: Array })
  readonly providersList!: ProviderModel[]

  @Prop({ required: true, default: () => ([]), type: Array })
  readonly networkTypesList!: NetworkType[]

  @Prop({ required: true, default: '', type: String })
  readonly countryCode!: string

  @Emit('on-location-success')
  onLocationSuccess (location: GeolocationPosition) {
    return location
  }

  @Emit('on-location-error')
  onLocationError (e: GeolocationPositionError) {
    return e
  }

  @Emit()
  onPlaceChanged (place: google.maps.places.PlaceResult) {
    return place
  }

  @Watch('selectedProviderId', {
    immediate: true,
  })
  onProviderChange () {
    if (this.networkTypesList.includes(this.selectedNetworkType) ||
      !this.networkTypesList.length) {
      return
    }

    // Reset network type filter
    this.selectedNetworkType = this.networkTypesList[0]
  }
}
